import "./__page.scss"; import "./paginate.scss"

